(() => {
  const root = document.querySelector('[data-pw-evidence]');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const input = root.querySelector('input[type=file]'), output = root.querySelector('[data-evidence-urls]');
  const status = root.querySelector('[role=status]'), form = root.closest('form'), submit = form.querySelector('[type=submit]');
  const endpoint = root.dataset.endpoint.replace(/\/$/, '');
  let complete = false, busy = false;
  const types = {jpg:'image/jpeg',jpeg:'image/jpeg',png:'image/png',webp:'image/webp',mp4:'video/mp4',mov:'video/quicktime'};
  const request = async (path, body) => {
    const response = await fetch(endpoint + path, {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body),signal:AbortSignal.timeout(45000)});
    const data = await response.json();
    if (!response.ok) throw Error(data.error || 'The upload could not be confirmed.');
    return data;
  };
  const upload = (target, file, progress) => new Promise((resolve, reject) => {
    const data = new FormData();
    target.parameters.forEach(p => data.append(p.name,p.value));
    data.append('file',file,target.filename);
    const xhr = new XMLHttpRequest();
    xhr.open('POST',target.url); xhr.timeout = 300000;
    xhr.upload.onprogress = e => {if(e.lengthComputable) progress(Math.round(e.loaded/e.total*100));};
    xhr.onload = () => xhr.status >= 200 && xhr.status < 300 ? resolve() : reject(Error('Upload failed. Please choose the file again.'));
    xhr.onerror = () => reject(Error('Connection interrupted. Please choose the file again.'));
    xhr.ontimeout = () => reject(Error('Upload timed out. Please choose a smaller file or try again.'));
    xhr.send(data);
  });
  const fail = message => {status.textContent=message; input.setCustomValidity(message); complete=false; output.value='';};
  submit.disabled = true;
  if (!/^https:\/\//.test(endpoint)) {fail('Uploads are temporarily unavailable. Please contact support@powerwill.com.'); input.disabled=true; return;}
  input.addEventListener('change', async () => {
    if (busy) return;
    complete=false; output.value=''; submit.disabled=true; input.setCustomValidity('');
    const files=Array.from(input.files);
    if (!files.length || files.length>3) {fail('Choose 1–3 photos or videos before submitting.');return;}
    for(const file of files){
      const type=types[file.name.split('.').pop().toLowerCase()];
      if (!type || (file.type && file.type!==type) || !file.size || file.size>(type.startsWith('video/')?100:20)*1024*1024){fail('Use JPG, PNG, WebP (20 MB max), MP4 or MOV (100 MB max).');return;}
    }
    busy=true;input.disabled=true;const saved=[];
    try{
      for(let i=0;i<files.length;i++){
        const file=files[i], type=types[file.name.split('.').pop().toLowerCase()];
        status.textContent=`Preparing file ${i+1} of ${files.length}…`;
        const target=await request('/start',{type,size:file.size});
        await upload(target,file,p=>{status.textContent=`Uploading file ${i+1} of ${files.length}: ${p}%`;});
        status.textContent=`Processing file ${i+1} of ${files.length}…`;
        let result=await request('/finish',{ticket:target.ticket});
        for(let n=0;result.status!=='READY'&&n<80;n++){
          await new Promise(resolve=>setTimeout(resolve,3000));
          result=await request('/status',{ticket:target.ticket});
        }
        if(result.status!=='READY'||!result.url)throw Error('Processing is taking longer than expected. Please try a smaller file.');
        saved.push(`${result.reference}: ${result.url}`);
      }
      output.value=saved.join('\n'); output.textContent=output.value; output.hidden=false; complete=true; input.setCustomValidity('');
      status.textContent=`${saved.length} file${saved.length===1?'':'s'} uploaded successfully. You can submit your request.`;
    }catch(error){fail(error.message || 'Upload failed. Please choose your files again.');input.value='';}
    finally{busy=false;input.disabled=false;submit.disabled=!complete;}
  });
  form.addEventListener('submit',event=>{
    if(!complete||busy||!output.value){event.preventDefault();fail('Upload at least one photo or video before submitting.');input.reportValidity();}
  },true);
})();
